import React, { Component } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer'
import AboutMe from './components/AboutMe';
import Skills from './components/Skills';
import Projects from './components/Projects';
import ContactUs from './components/ContactUs';
import Education from './components/Education';
import Experience from './components/Experience'
import Certificates  from './components/Certificates'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

class App extends Component{

  render(){
    return(
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<AboutMe />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/aboutme" element={<AboutMe />} />
          <Route path="/education" element={<Education />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/certificates" element={<Certificates />} />
        </Routes>
        <Footer />
      </Router>
    )
  }
}

export default App;